import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { queryClient } from '@/shared/api/query-client';
import App from '@/App.vue';
import { router } from '@/app/router';
import { useBrandingStore } from '@/shared/branding/branding.store';
import '@/styles/main.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.use(VueQueryPlugin, { queryClient });

/**
 * FRONT-004 — the last resort for anything that escapes a component boundary. Nothing is
 * ever swallowed silently: an error nobody records is an error nobody fixes.
 *
 * In production this is where a monitoring SDK (Sentry or equivalent) is wired in.
 */
app.config.errorHandler = (error, _instance, info) => {
   
  console.error('[rrhh] unhandled application error', { error, info });
};

/**
 * Branding is applied synchronously from the cache and revalidated in parallel with the
 * mount. Awaiting the request instead would trade the flash of default theme for a blank
 * screen, and a blank screen is worse.
 */
const branding = useBrandingStore();
branding.applyCached();
void branding.revalidate();

app.mount('#app');
